import * as React from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

type BrokerFirmSalesInformationProps = {
    label: string;
    salesInformation: string;
    onChange: (event: any) => void;
};

export function BrokerFirmSalesInformation({
    label,
    salesInformation,
    onChange
}: BrokerFirmSalesInformationProps) {
    return (
        <FormGroup controlId="salesInformation">
            <ControlLabel>{label}</ControlLabel>
            <FormControl
                componentClass="textarea"
                name="salesInformation"
                rows={3}
                value={salesInformation}
                onChange={onChange}
            />
        </FormGroup>
    );
}
